module.exports = __webpack_public_path__ + "img/paperplane.53682b96.svg";